import React from "react";
import ReactDOM from "react-dom";
import "whatwg-fetch";

import App from "./App";

let data = fetch(`assets/schools.json`).then(r => r.json());
// let chartdata = fetch(`assets/chartsdata.json`).then(r => r.json());

let asbestos = fetch(`assets/asbestos.json`).then(r => r.json());
let reports = fetch(`assets/reports.json`).then(r => r.json());
let water = fetch(`assets/water.json`).then(r => r.json());
let food = fetch(`assets/foodinspection.json`).then(r => r.json());
let asbestos2020 = fetch(`assets/asbestos2020.json`).then(r => r.json());

// let path = location.hash.slice(1);
// if (path) {
//   location.hash = '';
//   history.replaceState({}, '', `${ROOT_URL}${path}`);
// }

// let path = window.location.hash.slice(1);
// if (path) {
//     window.location.hash = '';
//     window.history.replaceState({}, '', `${ROOT_URL}${path}`);
// }

// Promise.all([data])
//   .then(([data]) => {
//
//   });

Promise.all([data, asbestos, reports, water, food, asbestos2020]).then(
  ([data, asbestos, reports, water, food, asbestos2020]) => {
    var usechartdata = {
      asbestos: [],
      lead: [],
      water: [],
      asthma: [],
      asbestos2020: []
    };

    data.forEach(function(r) {
      if (r["Link with ULCS"] && r["Publication Name"]) {
        usechartdata.asbestos.push({
          school: r["Publication Name"],
          ULCS: r["Link with ULCS"],
          schooltype: r["On Dist web site"],
          enrollment: r["2017-18 Total Enrolled"],
          reports: 0,
          latlong: r["GPS Location"]
        });
        usechartdata.asbestos2020.push({
          school: r["Publication Name"],
          ULCS: r["Link with ULCS"],
          schooltype: r["On Dist web site"],
          enrollment: r["2017-18 Total Enrolled"],
          reports: 0,
          inPDF: r["Has PDF 1819"] ? "x" : ""
        });
        usechartdata.water.push({
          school: r["Publication Name"],
          ULCS: r["Link with ULCS"],
          schooltype: r["On Dist web site"],
          enrollment: r["2017-18 Total Enrolled"],
          reports: 0
        });
        usechartdata.asthma.push({
          school: r["Publication Name"],
          ULCS: r["Link with ULCS"],
          schooltype: r["On Dist web site"],
          enrollment: r["2017-18 Total Enrolled"],
          reports: 0
        });
        usechartdata.lead.push({
          school: r["Publication Name"],
          ULCS: r["Link with ULCS"],
          schooltype: r["On Dist web site"],
          enrollment: r["2017-18 Total Enrolled"],
          reports: 0
        });
      }
    });
    console.log(usechartdata);

    asbestos.forEach(function(r) {
      usechartdata.asbestos.forEach(function(i) {
        if (i.ULCS === r.key) {
          i.reports += 1;
        }
      });
    });
    asbestos2020.forEach(function(r) {
      usechartdata.asbestos2020.forEach(function(i) {
        if (i.ULCS === r.key) {
          i.reports += 1;
        }
      });
    });

    water.forEach(function(r) {
      usechartdata.water.forEach(function(i) {
        if (i.ULCS === r.key) {
          i.reports += 1;
        }
      });
    });

    food.forEach(function(r) {
      if (r.ULCS_f.length === 4) {
        usechartdata.asthma.forEach(function(i) {
          if (i.ULCS === Number(r.ULCS_f)) {
            i.reports += 1;
          }
        });
      }
    });

    reports
      .filter(q => q["Category"] === "Damaged paint and plaster")
      .forEach(function(r) {
        usechartdata.lead.forEach(function(i) {
          if (i.ULCS === r.UCLS) {
            i.reports += 1;
          }
        });
      });
    reports
      .filter(q => q["Category"] === "Asbestos")
      .forEach(function(r) {
        usechartdata.asbestos.forEach(function(i) {
          if (i.ULCS === r.UCLS) {
            i.reports += 1;
          }
        });
      });
    reports
      .filter(
        q =>
          (q["Category"] === "Air quality, allergies and asthma") |
          (q["Category"] === "Mold, leaks and moisture") |
          (q["Category"] === "Rodents and insects")
      )
      .forEach(function(r) {
        usechartdata.asthma.forEach(function(i) {
          if (i.ULCS === r.UCLS) {
            i.reports += 1;
          }
        });
      });

    // var unique = [...new Set(data.map(function(a) {
    //     if(a["Include in tool"]) {
    //         return a["Link with ULCS"]
    //     }
    // }))];

    ReactDOM.render(
      <App
        data={data}
        asbestos={asbestos}
        asbestos2020={asbestos2020}
        reports={reports}
        water={water}
        food={food}
        testdata={usechartdata}
      />,
      document.getElementById("root")
    );
  }
);

// ReactDOM.render((
//     <App/>
// ), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js